import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { colors, fonts } from '../tokens';
import { EnPowerWordmarkInline } from '../../EnPowerLogo';

const ContactRow = ({ icon: Icon, value, bg, iconColor }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
    <div
      style={{
        width: '22px',
        height: '22px',
        background: bg,
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Icon size={10} color={iconColor} />
    </div>
    <span
      style={{
        fontFamily: fonts.body,
        fontSize: '9.5px',
        color: colors.navy,
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </span>
  </div>
);

/**
 * ContactCard – Ansprechpartner-Karte im Alternatives-Grid auf Page 4.
 */
export const ContactCard = ({ name, company = 'EN:POWER GmbH', telefon, email }) => (
  <div className="contact-card" style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', boxSizing: 'border-box' }}>
    <div>
      <p style={{ fontFamily: fonts.body, fontSize: '7.5px', fontWeight: 700, color: colors.slateLight, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '6px' }}>Ihr Ansprechpartner</p>
      <p style={{ fontFamily: fonts.display, fontSize: '13px', fontWeight: 700, color: colors.navy, marginBottom: '2px' }}>{name}</p>
      <p style={{ fontFamily: fonts.body, fontSize: '9px', fontWeight: 600, color: colors.orange, marginBottom: '10px' }}>
        {company === 'EN:POWER GmbH' ? (
          <>
            <EnPowerWordmarkInline
              enColor={colors.navy}
              powerColor={colors.orange}
              fontFamily={fonts.body}
              fontSize="9px"
              fontWeight={700}
              letterSpacing="0.03em"
            />
            <span style={{ color: colors.navy }}> GmbH</span>
          </>
        ) : company}
      </p>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <ContactRow icon={Phone} value={telefon} bg="rgba(18,42,92,0.06)" iconColor={colors.navy} />
      <ContactRow icon={Mail} value={email} bg="rgba(224,112,0,0.08)" iconColor={colors.orange} />
    </div>
  </div>
);
